var _defs, _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgExpiry3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30.8 30.8"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;fill-rule:evenodd}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M15.4 0a15.4 15.4 0 1015.4 15.4A15.39 15.39 0 0015.4 0m0 1.34A14.06 14.06 0 111.34 15.4 14.08 14.08 0 0115.4 1.34"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M18.13 26.12a.66.66 0 01-.63-.46l-3-9.31a.65.65 0 010-.2V9.34a.66.66 0 01.67-.68.67.67 0 01.67.67v6.72l3 9.2a.66.66 0 01-.43.84h-.21"
  })));
}

SvgExpiry3.displayName = 'Expiry3';
export default SvgExpiry3;